import React from "react";
import styles from 'features/borswer-not-support/index.module.scss';

const BrowserNotSupport = () => {

  return (
    <div className={styles.page}>
      您的瀏覽器目前不支援顯示。請改用 Google Chrome 或 Microsoft Edge 瀏覽器繼續。
    </div>
  )
};


export default BrowserNotSupport
